export default __webpack_public_path__ + "static/PolySans-Neutral-ff42fdb9b1d735443b731076965b2b30.woff2";